import axios from 'axios'

const baseURL = '/back-office/v3/communications/notifications'

export default class ApiManager {
    /**
     * Create or update a notification.
     * @param {string} params – JSON-stringified form data
     */
    static update(params) {
        return axios
            .post(`${baseURL}/store`, params, {
                headers: { 'Content-Type': 'application/json' },
            })
            .then((res) => res.data)
            .catch((error) => {
                console.error('NotificationPush store error:', error)
                throw error
            })
    }

    /**
     * Fetch a single notification by ID.
     * @param {number} id
     */
    static get(id) {
        return axios
            .get(`${baseURL}/${id}`)
            .then((res) => res.data.NotificationPush)
            .catch((error) => {
                console.error('NotificationPush fetch error:', error)
                throw error
            })
    }

    /**
     * Delete a notification by ID.
     * @param {number} id
     */
    static destroy(id) {
        return axios
            .delete(`${baseURL}/destroy/${id}`)
            .then((res) => res.data)
            .catch((error) => {
                console.error('NotificationPush delete error:', error)
                throw error
            })
    }
}
